import React from 'react';
import AccountPage from '@/components/organisms/account';

const AccountPageTastic = () => {
  return <AccountPage />;
};

export default AccountPageTastic;
